
import { BaseService } from './BaseService';
import createMutation from '@/graphql/mutations/milestone/Create.gql';
import deleteMutation from '@/graphql/mutations/milestone/Delete.gql';
import checkMutation from '@/graphql/mutations/milestone/Check.gql';
import reorderMutation from '@/graphql/mutations/milestone/Reorder.gql';
import updateMutation from '@/graphql/mutations/milestone/Update.gql';
import { MilestoneInput, MilestoneCheckInput } from '@/types/graphql/schemaTypes';

class MilestoneService extends BaseService {
  public createMilestone(milestoneArgs: MilestoneInput, shipmentId: string) {
    return this.client.mutate({
      mutation: createMutation,
      variables: {
        milestoneArgs,
        shipmentId
      }
    });
  }

  public deleteMilestone(id: string) {
    return this.client.mutate({
      mutation: deleteMutation,
      variables: {
        id
      }
    });
  }

  public checkMilestone(milestoneArgs: MilestoneCheckInput) {
    return this.client.mutate({
      mutation: checkMutation,
      variables: {
        milestoneArgs
      }
    });
  }

  public reorderMilestones(milestoneIds: string[], shipmentId: string) {
    return this.client.mutate({
      mutation: reorderMutation,
      variables: {
        milestoneIds,
        shipmentId
      }
    });
  }

  public updateMilestone(
    milestoneArgs: MilestoneInput,
    milestoneId: string
  ) {
    return this.client.mutate({
      mutation: updateMutation,
      variables: {
        milestoneArgs,
        milestoneId
      }
    });
  }
}

export const milestoneService = new MilestoneService();
